import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProjectSettingsResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareReleaseNotesRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/softwareReleaseNotesRoute.tsx';
import { classicSoftwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { SpaReleaseNoteRedirectToVersionDetails } from './ui/index.tsx';

export const softwareReleaseNotesRouteEntry: Route = createEntry(softwareReleaseNotesRoute, () => ({
	group: 'project-settings-software',

	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		...getNavigationSidebarProjectSettingsResource(),
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		getConsolidationStateResource(),
	],

	// eslint-disable-next-line no-restricted-syntax
	component: SpaReleaseNoteRedirectToVersionDetails,
	layout: classicSoftwareProjectLayoutNoOnboarding,

	navigation: {
		menuId: MenuIdProjects,
		sidebarId: SidebarIdProjectSettings,
	},

	forPaint: [LazyAtlassianNavigation],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
